module.exports = __webpack_public_path__ + "static/brevet-4f35e7c817a967e79d21ce1dc50e1e5c.png";